import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    apartment: [
//         {
//             whereabouts: '大阪市北区',
//             buildingName: '建物1',
//             houseNumber1: '家屋番号1',
//             proprietaryPartBuildingName: '建物の名称1',
//             type: '種類1',
//             construction: '構造1',
//             floorSpace: '床面積1',
//             landCode: '土地の符号1',
//             locationLotNumber: '土地の所在1',
//             ground: '地積1',
//             realEstate: '地目1',
//             siteRightLandCode: '土地の符号1',
//             siteRightType: '敷地権の種類1',
//             siteRightPercentage: '敷地権の割合1',
//             targetPerson: 'テスト相続人1',
//             inheritanceBequest: '相続',
//         },
//         {
//             whereabouts: '所在2',
//             buildingName: '建物2',
//             houseNumber1: '家屋番号2',
//             proprietaryPartBuildingName: '建物の名称2',
//             type: '種類2',
//             construction: '構造2',
//             floorSpace: '床面積2',
//             landCode: '土地の符号2',
//             locationLotNumber: '土地の所在2',
//             ground: '地積2',
//             realEstate: '地目2',
//             siteRightLandCode: '土地の符号2',
//             siteRightType: '敷地権の種類2',
//             siteRightPercentage: '敷地権の割合2',
//             targetPerson: 'テスト相続人2',
//             inheritanceBequest: '相続',
//         },
//         {
//             whereabouts: '所在3',
//             buildingName: '建物3',
//             houseNumber1: '家屋番号3',
//             proprietaryPartBuildingName: '建物の名称3',
//             type: '種類3',
//             construction: '構造2',
//             floorSpace: '床面積3',
//             landCode: '土地の符号3',
//             locationLotNumber: '土地の所在3',
//             ground: '地積3',
//             realEstate: '地目3',
//             siteRightLandCode: '土地の符号3',
//             siteRightType: '敷地権の種類3',
//             siteRightPercentage: '敷地権の割合3',
//             targetPerson: 'テスト相続人3',
//             inheritanceBequest: '相続',
//         }
    ]
};

const slice = createSlice({
    name: 'apartment',
    initialState,
    reducers: {
        setApartment: (state, action) => {
            return Object.assign({}, state, { apartment: state.apartment.concat(action.payload) })
        },
        clearApartment: (state, action) => {
            const newArray = Array.from(new Set([...state.apartment]));
            newArray.splice(action.payload, 1)
            return Object.assign({}, state, { apartment: newArray })
        },
    }
});


export default slice.reducer;

export const {
    setApartment,
    clearApartment,
} = slice.actions;
